/* Syskonmatchning för "Finns i andra varianter" på slutsålda
   produktsidor. Delad modul: laddas i webbläsaren (product-soldout.js)
   OCH körs i Node av analysskriptet i scripts/slutsald-dold — ändra
   bara här så följer båda med.

   Princip: titlar jämförs som token-mängder efter att kända variantord
   (färger sv/en inkl. flerordsfärger, storlekar, mått) tagits bort.
   Kärnan som blir kvar ska vara identisk för äkta syskon:
   "Satisfyer Pro 2 Generation 3 Connect App Lilac" och
   "... Connect App Red Wine" har båda kärnan
   "satisfyer pro 2 generation 3 connect app". */

(function (root) {
  // Flerordsfärger/varianter — tas bort som fraser FÖRE tokenisering
  const MULTI_WORD_VARIANTS = [
    'red wine', 'deep rose', 'midnight black', 'jet black', 'hot pink',
    'deep skin tone', 'medium skin tone', 'light skin tone', 'skin tone',
    'dark blue', 'light blue', 'navy blue', 'royal blue', 'ocean blue',
    'sky blue', 'ice blue', 'petrol blue', 'cobalt blue', 'sapphire blue',
    'denim blue', 'aqua blue', 'turquoise blue', 'midnight blue',
    'baby pink', 'dusty pink', 'blush pink', 'powder pink', 'salmon pink',
    'neon pink', 'pastel pink', 'french rose', 'english rose', 'tea rose',
    'deep purple', 'dark purple', 'light purple', 'royal purple',
    'lavender purple', 'orchid purple', 'plum purple', 'cosmic purple',
    'galaxy purple', 'rose gold', 'glow in the dark', 'pearl white',
    'off white', 'ivory white', 'snow white', 'arctic white', 'polar white',
    'deep red', 'dark red', 'wine red', 'cherry red', 'ruby red',
    'fiery red', 'flame red', 'forest green', 'mint green', 'olive green',
    'emerald green', 'lime green', 'neon green', 'bottle green',
    'space grey', 'space gray', 'dark grey', 'dark gray', 'light grey',
    'light gray', 'steel grey', 'steel gray', 'deep teal', 'dark teal',
    'sunset orange', 'burnt orange', 'neon yellow', 'pastel blue',
    'dark brown', 'light brown', 'chocolate brown', 'caramel brown',
    'vanilla cream', 'night black', 'one size',
  ];

  // Enordsvarianter: färger (sv + en, inkl. böjningar), storleksord
  const SINGLE_WORD_VARIANTS = [
    // svenska färger
    'svart', 'svarta', 'vit', 'vita', 'vitt', 'röd', 'rod', 'röda', 'roda',
    'rött', 'rott', 'rosa', 'lila', 'blå', 'bla', 'blått', 'blatt', 'blåa',
    'grön', 'gron', 'gröna', 'grona', 'grönt', 'gront', 'gul', 'gula',
    'gult', 'brun', 'bruna', 'grå', 'gra', 'grått', 'gratt', 'guld',
    'turkos', 'cerise', 'vinröd', 'vinrod', 'marinblå', 'marinbla',
    'ljusrosa', 'mörkrosa', 'morkrosa', 'ljusblå', 'ljusbla', 'mörkblå',
    'morkbla', 'mörkgrön', 'morkgron', 'ljusgrön', 'ljusgron', 'mörklila',
    'morklila', 'ljuslila', 'aubergine', 'champagne', 'koppar', 'krom',
    'hudfärgad', 'hudfargad',
    // engelska färger
    'black', 'white', 'red', 'pink', 'purple', 'violet', 'lilac', 'blue',
    'green', 'yellow', 'brown', 'grey', 'gray', 'gold', 'golden', 'silver',
    'rose', 'fuchsia', 'magenta', 'cyan', 'teal', 'aqua', 'turquoise',
    'coral', 'mint', 'lavender', 'burgundy', 'bordeaux', 'wine', 'navy',
    'ivory', 'cream', 'nude', 'flesh', 'tan', 'caramel', 'chocolate',
    'espresso', 'mocha', 'vanilla', 'berry', 'cherry', 'plum', 'peach',
    'salmon', 'amber', 'copper', 'bronze', 'chrome', 'pearl', 'smoke',
    'transparent', 'clear', 'frosted', 'glitter', 'sparkle', 'blush',
    'crimson', 'scarlet', 'indigo', 'mauve', 'orchid', 'emerald', 'jade',
    'olive', 'lime', 'mustard', 'sand', 'stone', 'slate', 'graphite',
    'charcoal', 'onyx', 'beige',
    // storlekar (inkl. enbokstavsstorlekar) och variantbokstäver
    // (t.ex. "Masturbator Sleeve A/B/C")
    'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', 'small', 'medium', 'large',
    'mini', 'liten', 'stor', 'onesize', 'regular', 'slim',
    'a', 'b', 'c', 'd',
    // smaker (glidmedel m.m.)
    'watermelon', 'strawberry', 'raspberry', 'blueberry', 'pineapple',
    'banana', 'mango', 'melon', 'citrus', 'lemon', 'cola', 'bubblegum',
    'candy', 'jordgubb', 'jordgubbe', 'hallon', 'vattenmelon', 'ananas',
    'blåbär', 'blabar', 'körsbär', 'korsbar', 'vanilj', 'choklad',
    'lakrits',
  ];

  // Mått-/mängdtokens: 100ml, 250, 18cm, 12-pack osv (kräver enhet —
  // nakna siffror behålls, annars likställs t.ex. Generation 2 och 3)
  const MEASURE_RE = /^\d+([.,]\d+)?(ml|cl|l|cm|mm|m|g|kg|st|pack|pcs|x)$/;

  function coreOf(title) {
    let s = String(title || '')
      .toLowerCase()
      .replace(/[^a-z0-9åäöéü]+/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      // "30 ml"/"20 cm" → "30ml"/"20cm" så måttregexen fångar dem
      .replace(/\b(\d+([.,]\d+)?) (ml|cl|l|cm|mm|m|g|kg|st|pack|pcs)\b/g, '$1$3');
    for (const phrase of MULTI_WORD_VARIANTS) {
      s = s.replace(new RegExp(`(^| )${phrase}( |$)`, 'g'), ' ');
    }
    const tokens = s
      .split(' ')
      .filter(
        (t) =>
          t &&
          !SINGLE_WORD_VARIANTS.includes(t) &&
          !MEASURE_RE.test(t)
      );
    return tokens.join(' ');
  }

  /** Äkta syskon: samma kärna, samma vendor, samma produkttyp när satt. */
  function isSibling(own, candidate) {
    if (candidate.id === own.id) return false;
    if (candidate.vendor !== own.vendor) return false;
    if (own.type && candidate.type !== own.type) return false;
    const ownCore = coreOf(own.title);
    if (!ownCore) return false;
    return coreOf(candidate.title) === ownCore;
  }

  const api = { coreOf, isSibling };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.LustlySiblingMatch = api;
})(typeof self !== 'undefined' ? self : globalThis);
